import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  fetchAerolines,
  createAeroline,
  deleteAeroline,
  updateAeroline
} from '../../services/aerolines'
import { toast } from 'react-toastify';


export const getAerolines = createAsyncThunk(
  'aerolines/fetchAerolines',
  async (thunkAPI) => {
    try {
      const res = await fetchAerolines()
      return res.data
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  },
)

export const addAeroline = createAsyncThunk(
  'aerolines/addAeroline',
  async (data, thunkAPI) => {
    try {


      const res = await toast.promise(
        createAeroline(data).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se registró la aerolinea 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)


export const removeAeroline = createAsyncThunk(
  'aerolines/removeAeroline',
  async (id, thunkAPI) => {
    try {


      await toast.promise(
        deleteAeroline(id).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se eliminó la aerolinea 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      return id
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

export const editAeroline = createAsyncThunk(
  'aerolines/editAeroline',
  async ({ id, ...aeroline }, thunkAPI) => {
    try {

      const res = await toast.promise(
        updateAeroline(id, aeroline).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se actualizó la aerolinea 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      if (!res.data || res.data.length === 0) {
        // If no data returned (e.g. RLS blocked update), return the original data or throw error
        // For now, let's return the input data so the UI updates optimistically or at least doesn't crash
        return { id, ...aeroline }
      }
      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

